var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686",
    transform: "translate(-233 -143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4605",
    "data-name": "Rectangle 4605",
    width: 15,
    height: 15,
    rx: 2,
    transform: "translate(233 143)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M2.859-3.049a.4.4,0,0,0,.421-.435V-9.106h1.8a.372.372,0,0,0,.4-.379.372.372,0,0,0-.4-.379H.642a.372.372,0,0,0-.4.379.372.372,0,0,0,.4.379h1.8v5.623A.4.4,0,0,0,2.859-3.049Zm3.859.019a.4.4,0,0,0,.421-.435v-2.32H8.753L10.1-3.3a.417.417,0,0,0,.412.271.4.4,0,0,0,.43-.388.57.57,0,0,0-.089-.295l-1.235-2.2a1.927,1.927,0,0,0,1.357-1.937A1.96,1.96,0,0,0,8.828-9.864H6.718a.4.4,0,0,0-.421.435v5.964A.4.4,0,0,0,6.718-3.03Zm.421-3.5V-9.116H8.715a1.237,1.237,0,0,1,1.394,1.291,1.2,1.2,0,0,1-1.357,1.3Z",
    transform: "translate(234.891 156.947)",
    fill: "#f7f7f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrOut);
export default __webpack_public_path__ + "static/media/TrOut.c96ae99d271d0ffd55c5ef86f839d585.svg";
export { ForwardRef as ReactComponent };